import { Col, Container, Row } from 'react-bootstrap';

const PageNotFound = () => {
  return (
    <Container>
      <Row>
        <Col>
          <h1>404 - Pagina non trovata</h1>
        </Col>
      </Row>
    </Container>
  );
};

export default PageNotFound;
